export default __webpack_public_path__ + "static/media/back2.92931d35.svg";